__turbopack_context__.v({
  "backToExplorer": "BackToExplorer-module-scss-module__YRodma__backToExplorer",
  "mobile": "BackToExplorer-module-scss-module__YRodma__mobile",
});
